import { Box, ColorOptions, Icon, ModBox, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { useWindowDimensions } from '../../../util/util'
import { styles } from './styles'

const BankPaymentData: FC<any> = ({ data, isEditMode }: any) => {
  const viewPortWidth = useWindowDimensions()

  const themes = styles(viewPortWidth)

  return (
    <ModBox show={!isEditMode} {...themes.detailsContainer}>
      <TextNew type="titleBold16">{'Payment Methods'}</TextNew>
      <Spacer size={16} />
      <Box {...themes.detailsMainContainer}>
        <Box {...themes.detailsContent}>
          <Box {...themes.detailsBeneSubContainer}>
            <Box direction="row" alignItems={'center'}>
              <Icon id={'BANK'} size={14} color={'#8E8E8E' as ColorOptions} />
              <Spacer size={10} direction="horizontal" />
              <TextNew fontSize={12} fontFamily="jiotype-medium" color={'BLACK_75'}>
                {'Account Number'}
              </TextNew>
            </Box>
            <Spacer size={4} />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color={'BLACK_75'}>
              {'       IFSC Code'}
            </TextNew>
            <Spacer size={4} />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color={'BLACK_75'}>
              {'       Beneficiary Name'}
            </TextNew>
            <Spacer size={4} />
          </Box>
          <Box {...themes.detailsBeneSubContainer}>
            <TextNew fontSize={12} fontFamily="jiotype-medium" color="BLACK_21">
              {data?.accountNumber}
            </TextNew>
            <Spacer size={4} />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color="BLACK_21">
              {data?.ifsc}
            </TextNew>
            <Spacer size={4} />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color="BLACK_21">
              {data?.name}
            </TextNew>
            <Spacer size={4} />
          </Box>
        </Box>
        <Box {...themes.divider} />
        <Box {...themes.detailsSideContainer}>
          <Box {...themes.detailsSubContainer}>
            <Box direction="row" alignItems={'center'}>
              <Icon id={'ACCOUNT'} size={14} color={'#8E8E8E' as ColorOptions} />
              <Spacer size={4} direction="horizontal" />
              <TextNew fontSize={12} fontFamily="jiotype-medium" color={'BLACK_75'}>
                {'UPI VPA'}
              </TextNew>
            </Box>
            <Spacer size={4} />
          </Box>
          <Box {...themes.detailsSubContainer}>
            <TextNew type="body12" fontWeight="MEDIUM" color="BLACK_21">
              {data?.vpa}
            </TextNew>
            <Spacer size={4} />
          </Box>
        </Box>
      </Box>
    </ModBox>
  )
}

export default BankPaymentData
